<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getMe} from '@/api/login.js'
import {viewCountAdd} from '@/api/index/index.js'
export default {
  name: 'App',
  created(){
    this.viewCountAdd()
  },
  data(){
     return{
     }
  },
  methods:{
    viewCountAdd(){
      viewCountAdd().then(res=>{
        if(res.data.code==0){

        }
      })
    }
  },
  mounted(){
    document.title='青岛科技馆'
    // getMe().then(res=>{
    //   if(res.data.code=='0'){
    //   }else if(res.data.code=='403'){
    //     localStorage.removeItem('userInfo')
    //     localStorage.removeItem('userAllInfo')
    //   }else{
    //     localStorage.removeItem('userInfo')
    //     localStorage.removeItem('userAllInfo')
    //   }
    // })
  }
}
</script>

<style>
 #app{
    overflow-x: hidden;
    width: 100vw!important;
 }
</style>
<!-- https://www.csdn.net/tags/NtTacgxsOTk3NzktYmxvZwO0O0OO0O0O.html -->



// WEBPACK FOOTER //
// src/App.vue